export default __webpack_public_path__ + "static/media/091-tiger.52baa329.svg";